module.exports = __webpack_public_path__ + "img/image 7.cf830980.png";